import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  getUserPublicPrivateListApi,
  addExistingTripApi,
  removeItineraryApi,
} from "../../../services/AdminService";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useAuth } from "../../../contexts/AuthProvider";
import { ItineraryListPlaceholder } from "../../../components/skeleton-placeholder";
import { NoDataFound } from "../../../components/no-data-found";
import GalleryLightbox from "../../../components/gallery-lightbox";
import { findCountryCity, totalItineraryDaysDetailsCount } from "../../../helpers";


const ItinerariesList = () => {
  const { authed, currencyData } = useAuth();
  const history = useHistory();
  const [itinerariesListData, setItinerariesListData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isExistingLoading, setIsExistingLoading] = useState(false);

  const getItineraryListData = async () => {
    setIsLoading(true);
    const Obj = {
      userId: authed?.user?._id,
      newCurrency: currencyData?.currency,
    };
    await getUserPublicPrivateListApi(Obj, async (res) => {
      // console.log("getUserPublicPrivateListApi ====", res);
      setIsLoading(false);
      if (res.status === 200) {
        const { data } = res.data;
        const result = data.sort((a, b) =>
          new Date(a) < new Date(b) ? 1 : -1
        );
        setItinerariesListData(result);
      } else {
        console.log(
          `Error: ${res.data?.message || "An unexpected error occurred."}`
        );
      }
    });
  };

  const handlePreview = (e, item, i) => {
    history.push(`/admin/itinerary-preview/?itineraryId=${item.id}`);
  };
  const handleEdit = async (data) => {
    setIsExistingLoading(true);
    const obj = {
      userId: authed?.user?._id,
      itineraryId: data._id,
      currency: currencyData?.currency,
    };

    await addExistingTripApi(obj, async (res) => {
      // console.log("addExistingTripApi res===>", res);
      setIsExistingLoading(false);
      if (res.status === 200) {
        history.push({
          pathname: "/admin/create-itinerary/",
          search: `itineraryId=${res.data.data._id}`,
        });
      } else {
        console.log(
          `Error: ${res.data?.message || "An unexpected error occurred."}`
        );
      }
    });
  };
  const handleDelete = async (e, data) => {
    await removeItineraryApi({ itineraryId: data._id }, async (res) => {
      // console.log("removeItineraryApi res===>", res);
      if (res.status === 200) {
        document.body.click();
        getItineraryListData();
      } else {
        console.log(
          `Error: ${res.data?.message || "An unexpected error occurred."}`
        );
      }
    });
  };

  useEffect(() => {
    getItineraryListData();
  }, []);
  return (
    <>
      <div className="content-body">
        <h1 className="d-col-title mb-3">List Itineraries</h1>
        {isLoading ? (
          <ItineraryListPlaceholder number={4} />
        ) : itinerariesListData?.length > 0 ? (
          itinerariesListData?.map((item, i) => {
            const totalItems = totalItineraryDaysDetailsCount(item);
            return (

              <div className="listitenaries-item mt-3">
                <div className="listitenaries-img-scroller" onClick={(e) => handlePreview(e, item, i)}>
                  <ul className="listitenaries-img-ul">
                    {item?.destinationCityDetails?.map((cityItem) =>
                      cityItem?.itineraryDatys?.map((dayItem, dayIndex) => {
                        return dayItem?.itineraryDaysDetails?.map((dtItem, dtIndex) => (
                          <GalleryLightbox
                            key={`${dayIndex}-${dtIndex}`}
                            thumbnails={dtItem.icon}
                            data={dtItem}
                          />
                        ));
                      })
                    )}
                    {totalItems > 7 && (
                      <li className="lit-img-count-item cursor-pointer">
                        <div className="lit-img-count-item-in">
                          <span>+{totalItems - 7}</span>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="listitenaries-top-bx">
                  <div className="listitenaries-item-title">
                    <span className="listitenaries-cust">
                      {item?.type_of_itinerary}
                    </span>
                    <h4>{item?.tour_name}</h4>
                    <p>
                      {item?.destinationCityDetails.reduce(
                        (accumulator, current) =>
                          accumulator + current?.itineraryDatys?.length,
                        0
                      )}{" "}
                      days <span>|</span> {item?.travellers_type} <span>|</span>
                      &nbsp;
                      {item?.destinationCityDetails &&
                        findCountryCity(item?.destinationCityDetails).map((country, index) => (
                          <span key={index}>
                            {country.country} {index < country.length - 1 && " - "} (
                            {country.cities.map((city, cityIndex) => (
                              <span key={cityIndex}>
                                {city}
                                {cityIndex < country.cities.length - 1 && ", "}
                              </span>
                            ))}
                            )
                          </span>
                        ))
                      }
                      <span>&nbsp;|&nbsp;</span>
                      {item?.no_adult_travellers} adults{" "}
                      {item?.no_children_travellers?.no_children !== 0 && ("and " +
                        item?.no_children_travellers?.no_children +
                        "Children")} {item?.no_infant_travellers !== 0 && ("and " + item?.no_infant_travellers + " Infants")}
                      {" "}
                      <span>|</span> Estimated cost:{" "}
                      {currencyData?.currency} {Math.floor(item?.estimated_Cost)}
                    </p>
                  </div>
                  <div className="listitenaries-item-btns">
                    <button
                      onClick={(e) => handlePreview(e, item, i)}
                      type="button"
                      className="btn"
                    >
                      <i className="bi bi-eye"></i>
                    </button>
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose
                      overlay={
                        <Popover>
                          <Popover.Body className="delete-popover-body-sty">
                            <h6>Are you sure?</h6>
                            <p>Customize this itinerary</p>
                            <div className="delete-btn-groups mt-2">
                              <button
                                onClick={() => handleEdit(item, i)}
                                type="button"
                                className="btn btn-primary-color"
                                disabled={isExistingLoading}>
                                  {isExistingLoading ? "Loading..." : "Yes"}
                              </button>
                              <button
                                onClick={() => document.body.click()}
                                type="button"
                                className="btn btn-danger ms-2"
                              >
                                No
                              </button>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <button type="button" className="btn edit-icon"></button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose
                      overlay={
                        <Popover>
                          <Popover.Body className="delete-popover-body-sty">
                            <h6>Are you sure?</h6>
                            <p>This itinerary will be deleted permanently</p>
                            <div className="delete-btn-groups mt-2">
                              <button
                                onClick={(e) => handleDelete(e, item, i)}
                                type="button"
                                className="btn btn-primary-color"
                              >
                                Yes
                              </button>
                              <button
                                onClick={() => document.body.click()}
                                type="button"
                                className="btn btn-danger ms-2"
                              >
                                No
                              </button>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <button
                        type="button"
                        className="btn delete-icon"
                      ></button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <NoDataFound text="No itinerary found" />
        )}
      </div>
    </>
  );
};

export default ItinerariesList;
